import React from 'react';
import { Stack } from 'expo-router';
import { observer } from '@legendapp/state/react';
import { View, StyleSheet } from 'react-native';
import { SettingsLayoutLogger } from '../../../utils/logger';
import theme from '../../../config/theme';

// Logger específico para este componente
const logger = SettingsLayoutLogger.Main;

const SettingsLayout = observer(() => {
  logger.debug('Renderizando SettingsLayout');
  
  return (
    <View style={styles.container}>
      <Stack 
        initialRouteName="index"
        screenOptions={{
          headerShown: false,
          contentStyle: {
            backgroundColor: theme.colors.background.secondary,
          },
        }}
      >
      </Stack>
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background.secondary,
  },
});

export default SettingsLayout; 